export type Review = {
  name: string;
  initials: string;
  avatarColor: string;
  meta: string;
  city: string;
  rating: number;
  timeAgo: string;
  service: string;
  text: string;
  ownerReply?: string;
};

export const reviewSummary = {
  average: 4.9,
  total: 127,
  distribution: [
    { stars: 5, count: 118 },
    { stars: 4, count: 7 },
    { stars: 3, count: 1 },
    { stars: 2, count: 0 },
    { stars: 1, count: 1 },
  ],
};

export const reviews: Review[] = [
  {
    name: 'Melissa Garrett',
    initials: 'MG',
    avatarColor: '#7b5ea7',
    meta: 'Local Guide · 34 reviews',
    city: 'Forney',
    rating: 5,
    timeAgo: '2 weeks ago',
    service: 'Flower bed stone',
    text: 'Had 3 other quotes for redoing our front flower beds and Dany was the only one who actually showed up when he said he would. Price was fair and he explained everything up front. They did the stone border and new mulch in one day and cleaned up so well you couldn’t tell they were there except for the beds looking amazing. Already booked them for the back yard.',
    ownerReply: 'Thank you Melissa! It was a pleasure working on your home. See you soon for the back yard!',
  },
  {
    name: 'Robert Nguyen',
    initials: 'RN',
    avatarColor: '#1e7f74',
    meta: '12 reviews',
    city: 'Rockwall',
    rating: 5,
    timeAgo: '1 month ago',
    service: 'Drainage',
    text: 'We had water pooling against the foundation every time it rained. Dany came out, looked at it for maybe 20 min and knew exactly what the problem was. French drain installed and we’ve had two big storms since — totally dry. Very professional crew.',
  },
  {
    name: 'Tasha Williams',
    initials: 'TW',
    avatarColor: '#c2571a',
    meta: 'Local Guide · 88 reviews',
    city: 'Mesquite',
    rating: 5,
    timeAgo: '3 weeks ago',
    service: 'Sod installation',
    text: 'Great work on our sod. Yard went from half dirt to full green in a day. Only reason I’m writing a long review is because they came back a week later on their own to check the watering. Who does that anymore??',
  },
  {
    name: 'Carlos Mendoza',
    initials: 'CM',
    avatarColor: '#3b6fb6',
    meta: '5 reviews',
    city: 'Sunnyvale',
    rating: 5,
    timeAgo: '2 months ago',
    service: 'Concrete work',
    text: 'Excelente trabajo. Replaced our cracked walkway and extended the patio. Clean lines, good finish, on budget. Communication was easy in English and Spanish. 100% recommend.',
  },
  {
    name: 'Jennifer Lowe',
    initials: 'JL',
    avatarColor: '#a8326e',
    meta: '21 reviews',
    city: 'Rowlett',
    rating: 4,
    timeAgo: '1 month ago',
    service: 'Power washing',
    text: 'Driveway and fence look brand new after power washing. Took a couple extra days to get on the schedule because of rain, but they kept me updated by text the whole time. Would use again.',
  },
  {
    name: 'Mark & Diane Fowler',
    initials: 'MF',
    avatarColor: '#4d7c2a',
    meta: '9 reviews',
    city: 'Plano',
    rating: 5,
    timeAgo: '4 months ago',
    service: 'Spring cleanup',
    text: 'We’re older and can’t keep up with the yard like we used to. Dany’s team did a full spring cleanup, trimmed everything, hauled off a whole trailer of debris. Polite, hard working, and honest. We have them on a regular schedule now.',
  },
];
